import { memo } from 'react';
import { LottieGif } from '@Sage/ssm-web5';
import dataWarningLottie from './WarningLottie.json';

const WarningGif = memo(() => <LottieGif src={dataWarningLottie} />);
export default WarningGif;
